import { Sheet } from '@/components/Sheet';
import { RANDOM_SIZES, type RandomSize } from '@/randomSet';
import { plural, useT } from '@/str';

const CARD =
  'bg-card border-border text-foreground hover:bg-muted rounded-card flex min-h-24 flex-col items-center justify-center gap-1 border border-b-[3px] px-3 py-4';

export function RandomSetSheet({
  onPick,
  onClose,
}: {
  onPick: (n: RandomSize) => void;
  onClose: () => void;
}) {
  const t = useT();

  return (
    <Sheet
      title={t.randomPick}
      large
      close={false}
      className="gap-3.5 pb-[calc(26px+max(env(safe-area-inset-bottom),var(--tg-viewport-safe-area-inset-bottom,0px)))] [&>div:nth-child(2)]:justify-center"
      onClose={onClose}
    >
      <p className="text-t12h text-faint m-0 -mt-2 self-center text-center">{t.longSet}</p>
      <div className="grid grid-cols-2 gap-2.5">
        {RANDOM_SIZES.map((n) => (
          <button
            key={n}
            type="button"
            data-size={n}
            aria-label={`${n} ${plural(n, t.randomUnit)}`}
            onClick={() => onPick(n)}
            className={CARD}
          >
            <span className="text-t28 font-extrabold tracking-tight tabular-nums">{n}</span>
            <span className="text-t12 text-faint font-bold">{plural(n, t.randomUnit)}</span>
          </button>
        ))}
      </div>
    </Sheet>
  );
}
